<template>
  <v-row dense>
    <v-col cols="12" md="12" sm="12">
      <h3 class="font-weight-black mb-5">Hipótesis Diagnóstica</h3>
    </v-col>

    <v-col
      v-for="question in questions"
      :key="question.idQuestion"
      cols="4"
      md="4"
      sm="4"
    >
      <validation-provider
        v-slot="{ errors }"
        rules="required"
        :name="question.name"
      >
        <v-autocomplete
          v-model="question.answerClosed"
          :items="question.answer"
          item-value="idAnswer"
          color="#59805c"
          :label="question.name"
          clearable
          :error-messages="errors"
          dense
          required
          @change="updateModal()"
          :disabled="isViewDetailsForm"
        >
          <template v-slot:selection="data">
            {{ data.item.name }}
          </template>
          <template v-slot:item="data">
            {{ data.item.name }}
          </template></v-autocomplete
        ></validation-provider
      >
    </v-col>
    <v-col cols="12" md="12" sm="12" class="mb-5">
      <h3 align="left">Nota médica:</h3>
      <br />
      <v-row class="mb-5">
        <v-col
          @click.right.prevent
          @copy.prevent
          @paste.prevent
          ondrop="return false;"
        >
          <validation-provider
            v-slot="{ errors }"
            name="Nota médica"
            rules="required"
          >
            <vue-editor
              v-model="model.content"
              :errors-message="errors"
              required
              :disabled="isViewDetailsForm"
              @input="onEditorInput"
            />
            <span class="error--text">{{ errors.toString() }}</span>
          </validation-provider>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { VueEditor } from "vue2-editor";
export default {
  props: {
    model: Object,
    isViewDetailsForm: Boolean,
    isEdit: Boolean,
  },
  components: {
    ValidationObserver,
    ValidationProvider,
    VueEditor,
  },
  data() {
    return {
      annexes: { firstAppointment: "", violence: "", referred: false },
      answersValue: [],
      questions: [],
    };
  },
  mounted() {
    this.setQuestions();
  },
  methods: {
    // keydown: function(e) {
    //    console.log(e)
    // },
    setQuestions() {
      let questionnarieAttch = this.model.questionnaireAttachments.map(
        (questionnarie) => {
          this.answersValue = questionnarie.questions.map((answers) => {
            return {
              answers: answers.answers.map((result) => {
                return {
                  idAnswer: result.idAnswer,
                };
              }),
            };
          });
          this.questions = questionnarie.questions.map((answers) => {
            return {
              idQuestion: answers.idQuestion,
              name: answers.name,
              typeAnswer: answers.typeAnswer,
              answerClosed: answers.answerClosed,
              answerOpen: answers.answerOpen,
              answersClosed: answers.answersClosed,
              answer: answers.answers.map((result) => {
                return {
                  idAnswer: result.idAnswer,
                  name: result.name,
                };
              }),
            };
          });
        }
      );
    },
    updateModal() {
      for (let i in this.questions) {
        if (
          this.questions[i].idQuestion ==
          this.model.questionnaireAttachments[0].questions[i].idQuestion
        ) {
          this.model.questionnaireAttachments[0].questions[
            i
          ].answerClosed = this.questions[i].answerClosed;
          this.model.questionnaireAttachments[0].questions[
            i
          ].answerOpen = this.questions[i].answerOpen;
          this.model.questionnaireAttachments[0].questions[
            i
          ].answersClosed = this.questions[i].answersClosed;
        }
      }
    },
    onEditorInput(html) {
      const plain = html.replace(/<[^>]*>/g, '')
      if (!plain.trim()) {
        this.model.content = ''
      } else {
        this.model.content = html
      }
    },
  },
};
</script>
